import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export class CivilianEmailSubscription
{
	public constructor(public email: string, public expiration: string, public signature: string, public subscribe: boolean)
	{

	}
}

@Injectable()
export class CivilianEmailSubscriptionRepository
{
	private requestMapping: string = "subscription";
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public updateSubscription(emailSubscription: CivilianEmailSubscription): Observable<void>
	{
		return this.http.put<void>(`${this.requestMapping}`, emailSubscription);
	}
}
